import React from 'react';
import { Link } from 'react-router-dom';

import style from './Expired.module.css';

const ExpiredResetPasswordPage = React.memo(() => (
  <section className={style.forgotPassword}>
    <h2 className={style.h2}>
      Your reset password link is expired. Please click{' '}
      <Link to="/login/forgot-password">here</Link> to get a new one.
    </h2>
  </section>
));

export default ExpiredResetPasswordPage;
